import { post, put, del, get } from 'aws-amplify/api';
import { processResponse } from './api_util';
import useSWR from 'swr'
import { mutate } from 'swr';
import { handleApiResponse } from './api_util';

async function getCaseCategories(types = "transaction", includeDefaultCategory = false) {
  const path = includeDefaultCategory ? `category/subcategory?includeDefaultCategory=true&types=${types}` : `category/subcategory?types=${types}`;
  const payload = {
    apiName: 'LivisiblyCaseCategoryApi',
    path: path
  }

  const restOperation = get(payload);


  const response = await restOperation.response;

  return processResponse(response)
}


export function useGetCaseCategories(shouldFetch = true, types = "transaction", includeDefaultCategory = false) {
  const result = useSWR(
    shouldFetch ? ['CASE_CATEGORIES', types, includeDefaultCategory] : null,
    (path) => getCaseCategories(types, includeDefaultCategory)
  );
  return result;
}

export function refetchCaseCategories(types = "transaction", includeDefaultCategory = false) {
  mutate(['CASE_CATEGORIES', types, includeDefaultCategory]);
}

async function getDefaultAssociatedLiabilityCategoryMap() {
  const payload = {
    apiName: 'LivisiblyCaseCategoryApi',
    path: 'category/asset/default_associated_liabilities'
  }

  const restOperation = get(payload);


  const response = await restOperation.response;

  return processResponse(response)
}

export function useGetDefaultAssociatedLiabilityMap(shouldFetch = true) {
  const result = useSWR(
    shouldFetch ? 'CASE_ASSET_CATEGORY_DEFAULT_ASSOCIATED_LIABILITY_MAP' : null,
    (path) => getDefaultAssociatedLiabilityCategoryMap()
  );
  return result;
}

async function getCaseCategoriesWithDRFAAndUsage() {
  const payload = {
    apiName: 'LivisiblyCaseCategoryApi',
    path: 'category/subcategory/drfa/usage'
  }

  const restOperation = get(payload);


  const response = await restOperation.response;

  return processResponse(response)
}


export function useGetCaseCategoriesWithDRFAAndUsage(shouldFetch = true) {
  const result = useSWR(
    shouldFetch ? 'CASE_CATEGORIES_WITH_DRFA_AND_USAGE' : null,
    (path) => getCaseCategoriesWithDRFAAndUsage()
  );
  return result;
}
